import type { FC } from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { styles } from './index.styles';

const getDisplayedValue = (value: number | null) =>
  value !== null ? `${Math.round(value * 100)}` : '--';

interface TooltipTitleProps {
  value: number | null;
  name: string;
}

const TooltipTitle: FC<TooltipTitleProps> = ({ value, name }) => (
  <Box
    sx={{
      textTransform: 'capitalize',
      maxWidth: '10rem',
    }}
  >
    {name}: {getDisplayedValue(value)}%
  </Box>
);

export interface BarGroupProps {
  kpiData: [number | null, string][];
  colorMap: [string, string][];
  useGradient?: boolean;
}

const BarGroup: FC<BarGroupProps> = ({
  kpiData,
  colorMap,
  useGradient = false,
}) => (
  <Stack
    direction="row"
    sx={{
      height: '100%',
      px: 0.125,
    }}
  >
    {kpiData.map(([value, name], i) =>
      value !== null && isNaN(value) ? null : (
        <Stack direction="column-reverse" key={i} sx={styles.barWrapper}>
          <Tooltip
            arrow
            enterTouchDelay={1}
            leaveTouchDelay={3000}
            placement="right"
            followCursor
            title={<TooltipTitle value={value} name={name} />}
          >
            <Box
              sx={[
                {
                  height: `${(value as number) * 100}%`,
                },
                styles.bar(colorMap[i % colorMap.length], useGradient),
              ]}
            >
              <Box sx={styles.barValue(colorMap[i % colorMap.length], value)}>
                <Box>
                  <Typography component="span" variant="caption">
                    {getDisplayedValue(value)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Tooltip>
        </Stack>
      ),
    )}
  </Stack>
);

export default BarGroup;
